module.exports = __webpack_public_path__ + "1d2842afacfc882904e6652d5ceba405.pdf";